import React from "react";
import { observer } from "mobx-react";

interface Props {
  onOpenQuiz: () => void;
}

const Hero: React.FC<Props> = ({ onOpenQuiz }) => (
  <header className="hero">
    <div className="hero-pattern" aria-hidden="true">
      <svg
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg x="6%" y="22%" overflow="visible">
          <use
            href="#courses-blob-1"
            fill="#FFA5BC"
            transform="scale(2.0)"
            opacity="0.16"
          ></use>
        </svg>
        <svg x="84%" y="76%" overflow="visible">
          <use
            href="#courses-blob-2"
            fill="#B798F2"
            transform="scale(2.4)"
            opacity="0.14"
          ></use>
        </svg>
        <svg x="50%" y="-15%" overflow="visible">
          <use
            href="#courses-blob-3"
            fill="#E8EBFF"
            transform="scale(1.8)"
            opacity="0.50"
          ></use>
        </svg>
        <svg x="68%" y="58%" overflow="visible">
          <use
            href="#courses-blob-1"
            fill="#F3EC7A"
            transform="scale(1.0)"
            opacity="0.30"
          ></use>
        </svg>
      </svg>
    </div>
    <button
      className="big-42-wallpaper"
      type="button"
      id="quizTrigger42"
      aria-label="Open the 'Which 42courses brain is yours?' quiz"
      onClick={() => onOpenQuiz()}
    >
      42
    </button>
    <div className="container">
      <span className="eyebrow">All courses</span>
      <h1 className="hero-title">
        40+ Mini MBAs to <em>unlock your potential</em>.
      </h1>
      <p className="hero-sub">
        Pick a skill area, take the course picker, or just have a wander
        <button
          type="button"
          className="quiz-trigger-dot"
          id="quizTriggerDot"
          aria-label="Open the spirit-teacher quiz"
          onClick={onOpenQuiz}
        >
          .
        </button>
        <strong>Every course is CPD-accredited</strong>, taught by leading
        practitioners, marked by a real human, and personalised to you.
      </p>
    </div>
  </header>
);

export default observer(Hero);
